import React, { Fragment } from "react";
import PropTypes from "prop-types";

import {
  Centered,
  SplitPanel,
  Separator,
  InformationText,
  MoreInformationCentered,
  Panel
} from "../../CardsStyled";
import { useTranslate } from "hooks/translation-hooks";
import CalendarAltIcon from "../../../Icons/CalendarAltIcon";
import AppointmentDetails from "../AppointmentDetails";

export const HistoricalAppointment = ({
  rawEventDate,
  description,
  moreInformation
}) => {
  const t = useTranslate();
  return (
    <SplitPanel>
      <InformationText>
        {t("history_appointment_confirmation_card-text_1")}
      </InformationText>
      <Centered>
        <CalendarAltIcon />
      </Centered>
      <Panel centered>
        <AppointmentDetails
          rawEventDate={rawEventDate}
          description={description}
        />
      </Panel>
      {moreInformation && (
        <Fragment>
          <Separator />
          <Centered>
            <p>{t("history_appointment_confirmation_card-text_2")}</p>
          </Centered>
          <MoreInformationCentered>
            &ldquo;{moreInformation}&rdquo;
          </MoreInformationCentered>
        </Fragment>
      )}
    </SplitPanel>
  );
};

HistoricalAppointment.propTypes = {
  rawEventDate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  moreInformation: PropTypes.string
};

export default HistoricalAppointment;
